import React from "react";
import {Element} from "react-scroll";
import {useTranslation} from "react-i18next";

function HomePage() {
    const {t} = useTranslation();
    return (
        <Element name="home" style={{ paddingTop: '115px' }}>
            <div className="homePageHeader">
                <h1>
                    {t("cleanEnvironment")}
                </h1>
                <h1>
                    <b>{t("clearConscience")}</b>
                </h1>
            </div>
        </Element>
    );
};

export default HomePage;